import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { QuotationActionConfirmationModalContentComponent } from './quotation-action-confirmation-modal-content.component';

// note: this is a stub/template modal and does not get its own entry point for opening a modal; instead, new components that effectively just fill the slots in this modal template get their own entry
@NgModule({
  imports: [ComponentsModule, CommonModule, UiModule, TrackingModule],
  declarations: [QuotationActionConfirmationModalContentComponent],
  exports: [QuotationActionConfirmationModalContentComponent],
})
export class QuotationActionConfirmationModalContentModule {}
